import { render, staticRenderFns } from "./ExtBlog.vue?vue&type=template&id=df6ca44a&"
import script from "./ExtBlog.vue?vue&type=script&lang=js&"
export * from "./ExtBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports